import React from 'react';
import { Icon, Tooltip } from 'antd';
import { T } from '@ekuaibao/i18n';
import styles from './textTip.module.less';
export default function TextTip(props) {
    var title = props.title, tip = props.tip;
    return (React.createElement("span", { className: styles['text-tip-wrapper'] },
        React.createElement("span", { className: "title" },
            React.createElement(T, { name: title })),
        React.createElement(Tooltip, { title: React.createElement(T, { name: tip }) },
            React.createElement(Icon, { type: "question-circle-o" }))));
}
